module.exports = __webpack_public_path__ + "static/_boredom-d70b91d85a95072f4d055a81dab8bae7.jpg";